import config from '@/config/index' // 路径配置
import {
    loading
} from '@/common/loading';
import {
    getQueryWarnData,
    // getIssueRangeList
} from '@/api/baseMsg';
export default {
    name: "warningQuery",
    data() {
        return {
            btnFlag: false,
            isLoading: false,
            startIssue: "",//开始期号
            endIssue: "",//结束期号
            showI1: false,//开始期号弹窗展示
            showI2: false,//结束期号弹窗展示
            issueDataS: [],//开始期号数组
            issueDataE: [],//结束期号数组
            currentDate: new Date(new Date().setDate(new Date().getDate() - 5)),//开始日期
            currentDate2: new Date(),//结束日期
            List: [
            //     {
            //     warnDataId: "A2021110315",
            //     area: "铜陵市",
            //     tradeName: "猪肉",
            //     unitMeasure: "元/500g",
            //     current: 26,
            //     last: 25,
            //     contemp: 23,
            //     ringRatio: 4.5,
            //     yearOnYear: 6.3,
            //     highest: 38,
            //     lowest: 30,
            //     warnInfo: "猪肉连续3期连涨",
            //     taskName: "原粮收购期收购价格监测日报",
            //     issue: "20211106",
            //     warnType: "同比涨跌幅",
            //     warnLevel: "02",
            //     warnTime: 1635868800000,
            //     enableStatus: "1"
            // },{
            //     warnDataId: "A2021110315",
            //     area: "铜陵市",
            //     tradeName: "猪肉",
            //     unitMeasure: "元/500g",
            //     current: 26,
            //     last: 25,
            //     contemp: 23,
            //     ringRatio: 4.5,
            //     yearOnYear: 6.3,
            //     highest: 38,
            //     lowest: 30,
            //     warnInfo: "猪肉连续3期连涨",
            //     taskName: "原粮收购期收购价格监测日报",
            //     issue: "20211106",
            //     warnType: "同比涨跌幅",
            //     warnLevel: "02",
            //     warnTime: 1635868800000,
            //     enableStatus: "1"
            // }
        ],//信息数组
        }
    },
    created() {
        this.initTime();
        this.init();
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
        init() {
            loading(true);
            // this.getIssueRangeList();
            this.getQueryWarnData();
        },
        onRefresh() {
            setTimeout(() => {
                this.isLoading = false;
                // this.init();
            }, 300);
        },
        onClickLeft() {
            // console.log('123')
            this.$router.push({
                path: '/',
            });
        },
        //置顶图标
        backTop() {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
        scrollToTop() {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            that.btnFlag = that.scrollTop > 130;
            // that.isBarNav = that.scrollTop > 10;
        },
        showStartI() {
            // 展示开始期号弹窗
            this.showI1 = true;
        },
        showEndI() {
            // 展示结束期号弹窗
            this.showI2 = true;
        },
        search() {
            // 搜索事件
            loading(true)
            this.getQueryWarnData();
        },
        onConfirm1() {
            // 开始期号弹窗确认
            let nowDate = this.currentDate;
            let year= nowDate.getFullYear();
            let month = nowDate.getMonth() + 1; if (month >= 1 && month <= 9) { month = `0${month}` };
            let day = nowDate.getDate();  if (day >= 1 && day <= 9) { day = `0${day}` };
            this.startIssue = `${year}-${month}-${day}`;
            this.showI1 = false;
        },
        onCancel1() {
            // 开始期号弹窗关闭
            this.showI1 = false;
        },
        onConfirm2() {
            // 结束期号弹窗确认
            let nowDate = this.currentDate2;
            let year= nowDate.getFullYear();
            let month = nowDate.getMonth() + 1; if (month >= 1 && month <= 9) { month = `0${month}` };
            let day = nowDate.getDate();  if (day >= 1 && day <= 9) { day = `0${day}` };
            this.endIssue = `${year}-${month}-${day}`;
            this.showI2 = false;
        },
        onCancel2() {
            // 结束期号弹窗关闭
            this.showI2 = false;
        },
        formatter(type, value) {
            if (type === 'year') {
                return `${value}年`;
            } else if (type === 'month') {
                return `${value}月`
            } else if (type === 'day') {
                return `${value}日`
            }
            return value;
        },
        convertDateFromString(dateString) {
            if (dateString) {
                var date = new Date(dateString.replace(/-/, "/"))
                return date;
            }
        },
        initTime() {
            //初始化显示时间函数
            let sD,
              sM,
              sY,
              eD,
              eM,
              eY = "";
            let today = new Date().getTime();
            eD = new Date().getDate();
            eM = new Date().getMonth() + 1;
            eY = new Date().getFullYear();
            this.endIssue = eY + "-" + eM + "-" + eD;
            
            // 获取一个月前的日期
            sD = new Date(new Date().setMonth(new Date().getMonth() - 1)).getDate()
            sM = new Date(new Date().setMonth(new Date().getMonth() - 1)).getMonth() + 1
            sY = new Date(new Date().setMonth(new Date().getMonth() - 1)).getFullYear()
            
            // 格式化月份和日期，保证是两位数
            if (eM >= 1 && eM <= 9) { eM = `0${eM}` }
            if (eD >= 1 && eD <= 9) { eD = `0${eD}` }
            if (sM >= 1 && sM <= 9) { sM = `0${sM}` }
            if (sD >= 1 && sD <= 9) { sD = `0${sD}` }
            
            this.endIssue = `${eY}-${eM}-${eD}`;
            this.startIssue = `${sY}-${sM}-${sD}`;
            this.currentDate = this.convertDateFromString(this.startIssue);
            this.currentDate2 = this.convertDateFromString(this.endIssue);
        },
        //  //预警查询期号范围
        //  getIssueRangeList(){
        //     getIssueRangeList({}).then(res=>{
        //         if(res.length>0){
        //             for(let i=0;i<res.length;i++){
        //                 this.issueDataS.push(res[i].issueCode);
        //                 this.issueDataE.push(res[i].issueCode);
        //             }
                    
        //         }
        //     })
        // },
         //预警查询
         getQueryWarnData(){
            getQueryWarnData({
                startIssue: this.startIssue,  
                endIssue: this.endIssue,  
                }).then(res=>{
                this.List=res;
                loading(false);
            })
        },
    }
}